import React from "react";
import { Field, pickFieldControlAriaProps } from "@design-system/Field/Field";
import { TagsInput } from "@design-system/TagsInput/TagsInput";
import { EMAIL_PATTERN, parseRecipientList } from "./nativeInvoiceFormHelpers";

interface Props {
    label: string;
    value: string;
    placeholder?: string;
    // Cap on committed addresses. Commits past the cap drop the oldest tags,
    // so a cap of 1 behaves as a single-value field: typing a new address
    // swaps out the current one.
    maxEmails?: number;
    // Detail-sourced addresses (reply-to, customer CC/BCC) pass false so the
    // chip has no remove control and Backspace will not delete it.
    isValueRemovable?: (value: string) => boolean;
    onChange: (value: string) => void;
}

export const EmailRecipientsField: React.FC<Props> = ({
    label,
    value,
    placeholder,
    maxEmails = 50,
    isValueRemovable = () => true,
    onChange,
}) => {
    const emails = parseRecipientList(value).slice(0, maxEmails);

    return (
        <Field label={label}>
            <Field.Control
                render={(controlProps) => (
                    <TagsInput
                        {...pickFieldControlAriaProps(controlProps)}
                        ref={controlProps.ref}
                        size="xl"
                        placeholder={placeholder}
                        value={emails}
                        isValidValue={(email) => EMAIL_PATTERN.test(email)}
                        isValueRemovable={isValueRemovable}
                        onValueChange={(nextEmails) =>
                            onChange(nextEmails.slice(-maxEmails).join(", "))
                        }
                    />
                )}
            />
        </Field>
    );
};
